import type { Account } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveAccount } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAccount } from "./useAccount"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateAccount() {
  const saveAccount = useSaveAccount()
  const { mutate } = useAccount()

  return useMemo(
    () => saveAccount && (async (account: PartialWithId<Account>) => {
      try {
        const response = await saveAccount(account)

        void mutate(response.data.account)
        return response
      } catch (e) {
        noticeError(
          e,
          "UpdateAccount",
          { account },
        )

        throw e
      }
    }),
    [
      saveAccount,
      mutate,
    ],
  )
}
